import workspaceQuery from 'graphql/queries/product/ProductsCertificateWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/ProductsCertificateListQuery.graphql';
import instanceQuery from 'graphql/queries/product/ProductsCertificateQuery.graphql';
import defaultQuery from 'graphql/queries/product/ProductsCertificateDefault.graphql';
import mutationQuery from 'graphql/mutations/product/ProductsCertificateMutation.graphql';
import fragment from 'graphql/fragments/product/ProductsCertificateFragment.graphql';

const Certificate = {
  type: 'Certificate',
  title: 'Certificates',
  formTitle: 'Certificate',
  formUrl: '/Products/Certificate/Details/',
  workspaceUrl: '/Products/Certificate/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'code',
  },
  fragment,
  screenReference: 'PRODUCT_CERTIFICATES',
};

export default Certificate;
